import React from "react";
import clsx from "clsx";

const GridContainer = ({ children, className = "", innerClassName = "" }) => {
	return (
		<div className={clsx("grid grid-cols-1 lg:grid-cols-12 gap-10 max-w-[1800px] mx-auto", className)}>
			<div
				className={clsx(
					"col-span-full lg:col-start-2 lg:col-span-10 px-4 sm:px-6 lg:px-0",
					innerClassName
				)}
			>
				{children}
			</div>
		</div>
	);
};

export default GridContainer;
